import React from 'react';
import { Wifi } from 'lucide-react';
export const InteractiveToySync = () => {
  return <section className="w-full rounded-xl bg-gray-900 border-0 sm:border sm:border-gray-800/30 overflow-hidden" data-id="element-8733">
      <div className="p-4 relative" data-id="element-8734">
        <div className="flex items-center justify-between mb-2" data-id="element-8735">
          <h2 className="text-lg font-bold" data-id="element-8736">Interactive Toy Sync</h2>
          <div className="text-xs px-2 py-0.5 rounded-full bg-indigo-500/30 text-indigo-400" data-id="element-8737">
            VIP Only
          </div>
        </div>
        <div className="flex items-center gap-3 mb-4" data-id="element-8738">
          <div className="w-8 h-8 flex items-center justify-center bg-pink-500/20 rounded-full text-pink-400" data-id="element-8739">
            <Wifi size={16} data-id="element-8740" />
          </div>
          <div data-id="element-8741">
            <h3 className="text-sm font-medium" data-id="element-8742">Connect your Lovense</h3>
            <p className="text-xs text-gray-400" data-id="element-8743">
              Experience real-time thrills with toy synchronization
            </p>
          </div>
        </div>
        <div className="space-y-3" data-id="element-8744">
          <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border-0 sm:border sm:border-gray-700/30" data-id="element-8745">
            <div className="flex items-center gap-2" data-id="element-8746">
              <span className="text-pink-400" data-id="element-8747">🔄</span>
              <span className="text-sm" data-id="element-8748">Lush 3</span>
            </div>
            <button className="text-xs px-3 py-1 rounded-full bg-gray-700 text-gray-300" data-id="element-8749">
              Connect
            </button>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg border-0 sm:border sm:border-gray-700/30" data-id="element-8750">
            <div className="flex items-center gap-2" data-id="element-8751">
              <span className="text-pink-400" data-id="element-8752">🔄</span>
              <span className="text-sm" data-id="element-8753">Max 2</span>
            </div>
            <button className="text-xs px-3 py-1 rounded-full bg-gray-700 text-gray-300" data-id="element-8754">
              Connect
            </button>
          </div>
        </div>
        <div className="flex flex-col items-center mt-6 mb-2" data-id="element-8755">
          <div className="w-12 h-12 flex items-center justify-center bg-pink-500/10 rounded-full mb-2" data-id="element-8756">
            <svg className="w-6 h-6 text-pink-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-8757">
              <path d="M12 10V17M12 10L16 6M12 10L8 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-8758" />
              <path d="M7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-8759" />
            </svg>
          </div>
          <h3 className="font-medium text-center" data-id="element-8760">Unlock Sensory Sync</h3>
          <button className="mt-3 px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white font-medium text-sm" data-id="element-8761">
            Upgrade to VIP
          </button>
        </div>
        <p className="text-xs text-center text-gray-400 mt-3" data-id="element-8762">
          Devices will vibrate in sync with interactions during chat and games
        </p>
      </div>
    </section>;
};